<template>
  <div>
    <el-table :data="items" @selection-change="selectionChange">
      <el-table-column type="selection" width="55">

      </el-table-column>
      <el-table-column v-for="(item,idx) in rfidConfig.heapSelectColumns" :key="idx" :label="item.label"
                       :prop="item.prop"></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import RfidEditConfig from "./RfidEditConfig";

  export default {
    props: ['taskId', 'items'],
    name: "RfidHeapSelect",
    data() {
      return {
        rfidConfig: RfidEditConfig,
        selectItems: []
      }
    },
    methods: {
      selectionChange(val) {
        this.selectItems = val;
      },
      getSelectList() {
        return this.selectItems;
      }
    }
  }
</script>

<style scoped>

</style>
